{
  "optionsOrders": {
    "ticker": "Ticker",
    "option": "Option",
    "tickerCompany": "Ticker/Company",
    "operation": "Operation",
    "quantity": "Quantity",
    "sum": "Amount",
    "profitability": "Profit",
    "dateTime": "Date/Time",
    "actions": "Actions",
    "price": "Price",
    "openedOrders": "Open Orders",
    "statusTitle": "Status",
    "term": "Term",
    "orderStatus": "Order Status",
    "empty": "No orders",
    "orderType": "Order Type",
    "info": "Information",
    "pcs": "pcs.",
    "total": "Total",
    "status": {
      "new": "New",
      "partially_filled": "Partially Filled",
      "filled": "Filled",
      "done_for_day": "Done for Day",
      "canceled": "Canceled",
      "expired": "Expired",
      "replaced": "Replaced",
      "pending_cancel": "Pending Cancel",
      "pending_replace": "Pending Replace",
      "accepted": "Processing",
      "pending_new": "Pending New",
      "rejected": "Rejected",
      "calculated": "Calculating",
      "accepted_for_bidding": "Accepted for Bidding",
      "stopped": "Stopped",
      "suspended": "Suspended",
      "held": "Held"
    },
    "side": {
      "buy": "Buy",
      "sell": "Sell",
      "sell_short": "Sell Short"
    },
    "activeOrders": {
      "filled": "Executed",
      "open": "Open",
      "canceled": "Canceled"
    },
    "types": {
      "market": "Market",
      "limit": "Limit",
      "stop": "Stop",
      "stop_limit": "Stop Limit",
      "trailing_stop": "Trailing Stop"
    },
    "attributes": {
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit"
    },
    "terms": {
      "day": "DAY",
      "gtc": "GTC",
      "opg": "OPG",
      "cls": "CLS",
      "ioc": "IOC",
      "dayPlus": "DAY+"
    },
    "orderSuccessfullyCanceled": "Order successfully canceled!",
    "cancel": "Cancel",
    "edit": "Edit"
  }
}
